/* eslint-disable import/prefer-default-export,jsx-a11y/control-has-associated-label */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export const PromoWarning = ({ setIsWarningVisible }) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <div className="promo-warning w-100 bg-primary align-items-center justify-content-center flex-row d-flex d-md-none p-2">
        <div className="w-90 flex-column d-flex">
          <p className="w-100 text-f6 text-center text-black">
            <Trans
              i18nKey="fca_banner"
              values={{
                learn_more: translate('learn_more'),
              }}
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  key="learn-more"
                  className="text-decoration-none text-black text-bold"
                  href="https://withcl.com/faq/"
                  rel="noreferrer"
                  target="_blank"
                />,
              ]}
            />
          </p>
        </div>
        <div className="w-10 ps-2">
          <i
            onClick={() => setIsWarningVisible(false)}
            onKeyDown={() => setIsWarningVisible(false)}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-black"
            tabIndex={-1}
            aria-label="Close"
          />
        </div>
      </div>
      <div className="w-100 bg-primary align-items-center flex-row d-none d-md-flex justify-content-center  p-2">
        <div className="w-90 flex-column d-flex">
          <p className="w-100 text-f6 text-center text-black ">
            <Trans
              i18nKey="fca_banner"
              values={{
                learn_more: translate('learn_more'),
              }}
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  key="learn-more"
                  className="text-decoration-none text-black text-bold"
                  href="https://withcl.com/faq/"
                  rel="noreferrer"
                  target="_blank"
                />,
              ]}
            />
          </p>
          <p className="w-100 text-f6 text-center text-black">{translate('fca_alt_banner')}</p>
        </div>
        <div className="w-10">
          <i
            onClick={() => setIsWarningVisible(false)}
            onKeyDown={() => setIsWarningVisible(false)}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-black"
            tabIndex={-1}
            aria-label="Close"
          />
        </div>
      </div>
    </>
  );
};

PromoWarning.propTypes = {
  setIsWarningVisible: PropTypes.func.isRequired,
};
